module.exports = __webpack_public_path__ + "9d256b9ba30b09bb070b5ebbf20c5831.svg";